import React, { Component } from "react"
import { connect } from "react-redux"

import { Table, Empty, Tag } from "antd"

import "asset/style/dashboard.css"
import { openEndPoint } from "utils/utils"
import { fetchAllFolderTags, fetchAllPatientFolders, updatePatientFolderSearchParams } from "redux_actions/patientfolder.state.action"
import NewFolderTag from "./NewFolderTag"
import Cancel from "@mui/icons-material/Cancel"
import { getCaseNamePlaceholder } from "utils/org_utils"
import { post } from "helper/request"

class PatientFolderTable extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount = () => {
        fetchAllFolderTags()
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.searchParams.tags !== this.props.searchParams.tags ||
            prevProps.searchParams.page !== this.props.searchParams.page ||
            prevProps.searchParams.ordering !== this.props.searchParams.ordering) {
            fetchAllPatientFolders()
        }
    }

    removeTag = (e, tag, folder_id) => {
        e.stopPropagation()
        post("/api/update_tags_in_folder/", { action: "remove", tags: [tag], folder_id }).finally(() => fetchAllPatientFolders())
    }

    columns = () => ([
        {
            title: `${getCaseNamePlaceholder()} Name`,
            dataIndex: "folder_name",
            key: "folder_name",
            defaultSortOrder: "ascend",
            sorter: (a, b) => a?.folder_name?.toString()?.toLowerCase()?.localeCompare(
                b.folder_name?.toString()?.toLowerCase()),
        },
        {
            title: "Tags",
            dataIndex: "tags",
            key: "tags",
            render: (tags, record) => [
                ...tags?.map(tag =>
                    <Tag key={tag} onClick={(e) => this.removeTag(e, tag, record.id)} style={{ display: "inline-flex" }}>
                        {/* <span style={{ display: "flex", alignItems: "center", width: "96px" }}> */}
                        <span style={{ margin: "3px 0 0 4px" }}>{tag}</span>
                        <Cancel style={{ transform: "scale(0.5)", padding: 0, margin: 0, }} />
                        {/* </span> */}
                    </Tag>
                ),
                <NewFolderTag folderId={record.id} />
            ],
            filters: this.props.allTags.map(tag => ({ "text": tag, "value": tag })),
            onFilter: (value, record) => record.tags.includes(value),
        },
        {
            title: "Created by",
            dataIndex: "created_by",
            key: "created_by"
        },
        {
            title: "Created On",
            dataIndex: "created_on",
            key: "created_on",
            defaultSortOrder: "descend",
            sorter: (a, b) => a.createdOnParsed - b.createdOnParsed,
        },
        {
            title: "Updated On",
            dataIndex: "last_updated_on",
            key: "last_updated_on",
            defaultSortOrder: "descend",
            sorter: (a, b) => a.lastUpdatedOnParsed - b.lastUpdatedOnParsed,
        },
        {
            title: "Number of Cases",
            dataIndex: "case_len",
            key: "case_len",
            defaultSortOrder: "descend",
            sorter: (a, b) => a.case_len - b.case_len
        }
    ])


    getDataSource = () => this.props.allPatientFolders?.map((e) => {
        const createdOnParsed = Date.parse(e?.created_on)
        const lastUpdatedOnParsed = Date.parse(e?.last_updated_on)

        return {
            ...e,
            created_by: this.props.allUsers[e?.created_by]?.username,
            created_on: (new Date(createdOnParsed)).toLocaleString(),
            createdOnParsed,
            last_updated_on: (lastUpdatedOnParsed - createdOnParsed) > 1000 ? (new Date(lastUpdatedOnParsed)).toLocaleString() : "--",
            lastUpdatedOnParsed,
            case_len: e.cases?.length || 0,
            tags: e?.tags.map(({ name }) => name) || [],
        }
    })

    handleChange = (pagination, filters, sorter) => {
        const { field, order } = sorter
        const ordering = `${order === "descend" ? "-" : ""}${field}`

        this.props.dispatch(updatePatientFolderSearchParams({ ...filters, ordering }))
        console.log('sorter', sorter, ordering)
    }

    handlePageChange = (page) => {
        this.props.dispatch(updatePatientFolderSearchParams({ page }))
    }

    render() {
        return (
            <Table
                className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                rowClassName="slide-table-rows custom-hover-table-box"
                columns={this.columns()}
                dataSource={this.getDataSource()}
                pagination={{
                    pageSize: 10,
                    total: this.props.totalCount,
                    onChange: this.handlePageChange,
                }}
                locale={{ emptyText: (<Empty description="No Folder Found" />) }}
                rowSelection={{
                    onChange: this.props.handleRowSelect,
                    selectedRowKeys: this.props.selectedRowKeys,
                    selectedRows: this.props.selectedRows,
                    columnWidth: '10px'
                }}
                size="small"
                onRowClick={({ id }) => openEndPoint(`/patient_folder/${id}`)}
                onChange={this.handleChange}
            />
        )
    }
}

const mapStateToProps = (state) => ({
    allPatientFolders: state.patientfolderReducer.allPatientFolders,
    allTags: state.patientfolderReducer.allTags,
    searchParams: state.patientfolderReducer.searchParamsMap,
    allUsers: state.caseStatusReducer.users,
    currPage: state.patientfolderReducer.page,
    totalPages: state.patientfolderReducer.totalPages,
    totalCount: state.patientfolderReducer.totalCount,
})

export default connect(mapStateToProps)(PatientFolderTable)